import { render, staticRenderFns } from "./ChatEmoji.vue?vue&type=template&id=220ca436&scoped=true&"
import script from "./ChatEmoji.vue?vue&type=script&lang=js&"
export * from "./ChatEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ca436",
  null
  
)

export default component.exports